import { FormControl, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";
import { DestinationViewType } from "generated-graphql/graphql";
import { useState } from "react";

import { DestinationsView } from "./DestinationsView";

interface DestinationsDataGridProps {
  wasteStreamId: string;
}

const viewOptions = [
  { value: DestinationViewType.Destinations, label: "Destinations" },
  { value: DestinationViewType.ManagementMethods, label: "Management Methods" },
  {
    value: DestinationViewType.DestinationsByManagementMethod,
    label: "Destinations by Management Method",
  },
];

export const DestinationsDataGrid = ({ wasteStreamId }: DestinationsDataGridProps) => {
  const [viewType, setViewType] = useState<DestinationViewType>(DestinationViewType.Destinations);

  return (
    <Stack spacing={2}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="subtitle1">Destinations</Typography>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>View by</InputLabel>
          <Select
            value={viewType}
            onChange={(e) => setViewType(e.target.value as DestinationViewType)}
            label="View by"
            size="small"
          >
            {viewOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
      <DestinationsView wasteStreamId={wasteStreamId} viewType={viewType} />
    </Stack>
  );
};
